/* Admission: "Cancel" on the questionnaire returns to the homepage (the form app itself points it at sign-in). */
(function(){
  if (!document.body.classList.contains('tpl-page--admission')) return;
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.cf-form-block .cf-cancel');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/';
  }, true);
})();
